import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { getLoaderValue } from "redux/loader";
import { useSelector } from "react-redux";

const Loader = () => {
  const loader = useSelector(getLoaderValue);
  return (
    <>
      {loader && (
        <div className="loader">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
    </>
  );
};
export default Loader;
